import {
  BaseEdge,
  Position,
  useInternalNode,
  EdgeLabelRenderer,
  getStraightPath,
} from "@xyflow/react";
import { useNavigate } from "react-router-dom";
import { useGraphStore } from "./store"
function getNodeIntersection(intersectionNode, targetNode) {
  // https://math.stackexchange.com/questions/1724792/an-algorithm-for-finding-the-intersection-point-between-a-center-of-vision-and-a
  const { width: intersectionNodeWidth, height: intersectionNodeHeight } =
    intersectionNode.measured;
  const intersectionNodePosition = intersectionNode.internals.positionAbsolute;
  const targetPosition = targetNode.internals.positionAbsolute;

  const w = intersectionNodeWidth / 2;
  const h = intersectionNodeHeight / 2;

  const x2 = intersectionNodePosition.x + w;
  const y2 = intersectionNodePosition.y + h;
  const x1 = targetPosition.x + targetNode.measured.width / 2;
  const y1 = targetPosition.y + targetNode.measured.height / 2;

  const xx1 = (x1 - x2) / (2 * w) - (y1 - y2) / (2 * h);
  const yy1 = (x1 - x2) / (2 * w) + (y1 - y2) / (2 * h);
  const a = 1 / (Math.abs(xx1) + Math.abs(yy1));
  const xx3 = a * xx1;
  const yy3 = a * yy1;
  const x = w * (xx3 + yy3) + x2;
  const y = h * (-xx3 + yy3) + y2;

  return { x, y };
}

// returns the position (top,right,bottom or right) passed node compared to the intersection point
function getEdgePosition(node, intersectionPoint) {
  const n = { ...node.internals.positionAbsolute, ...node };
  const nx = Math.round(n.x);
  const ny = Math.round(n.y);
  const px = Math.round(intersectionPoint.x);
  const py = Math.round(intersectionPoint.y);

  if (px <= nx + 1) {
    return Position.Left;
  }
  if (px >= nx + n.measured.width - 1) {
    return Position.Right;
  }
  if (py <= ny + 1) {
    return Position.Top;
  }
  if (py >= n.y + n.measured.height - 1) {
    return Position.Bottom;
  }

  return Position.Top;
}
function getEdgeParams(source, target) {
  const sourceIntersectionPoint = getNodeIntersection(source, target);
  const targetIntersectionPoint = getNodeIntersection(target, source);

  const sourcePos = getEdgePosition(source, sourceIntersectionPoint);
  const targetPos = getEdgePosition(target, targetIntersectionPoint);

  return {
    sx: sourceIntersectionPoint.x,
    sy: sourceIntersectionPoint.y,
    tx: targetIntersectionPoint.x,
    ty: targetIntersectionPoint.y,
    sourcePos,
    targetPos,
  };
}

function CustomEdge({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  markerStart,
  style,
  data: { isHovered, label, nonAttivo, idAvp,idNodo } = {},
}) {
    const { setSelectedNode } = useGraphStore((state) => state);
  
  const navigate = useNavigate();

  // const navigate = useNavigate();
  const sourceNode = useInternalNode(source);
  const targetNode = useInternalNode(target);
  if (!sourceNode || !targetNode) {
    return null;
  }
  const { sx, sy, tx, ty, sourcePos, targetPos } = getEdgeParams(
    sourceNode,
    targetNode
  );
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX: sx,
    sourceY: sy,
    targetX: tx,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetY: ty,
  });

  const handleOnClick = () => {
    setSelectedNode(idNodo)
    navigate(
      "/avp/grafo/nodo/arco?action=edit&idavp=" + idAvp + "&idarco=" + id
    );
  };

  const text =
    !isHovered && String(label).length > 10
      ? String(label).slice(0, 14) + "... "
      : String(label);
  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          strokeWidth: 2,
          stroke: nonAttivo ? "#CCCCCC" : "black",
          // stroke: "#FF0072",
          width: 600,
          borderStyle: "solid",
          border: 2,
          borderColor: nonAttivo ? "#CCCCCC" : "black",
        }}
        markerEnd={markerEnd}
        markerStart={markerStart}
      />
      <EdgeLabelRenderer
        onClick={() => {
          alert("ok");
        }}
      >
        <label
          style={{
            textAlign: "center",
            minWidth: 100,
            width: isHovered ? String(label).length * 3 : 100,
            fontSize: isHovered ? 20 : 15,
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            pointerEvents: "all",
            background: "white",
            color: nonAttivo ? "#CCCCCC" : "black",
            zIndex: isHovered ? 999 : 0,
            margin: 0,
          }}
          className="text-sm button-edge__label nodrag nopan"
          onClick={handleOnClick}
        >
          {text}
        </label>
      </EdgeLabelRenderer>
    </>
  );
}
export default CustomEdge;
